import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { TimedElementContext } from '../../TimedElement.context';
var propTypes = {
  children: ChildrenPropType,
  alwaysShow: PropTypes.bool
};
var defaultProps = {
  children: null,
  alwaysShow: false
};
export default function Element(_ref) {
  var children = _ref.children,
    alwaysShow = _ref.alwaysShow;
  var _useContext = useContext(TimedElementContext),
    shouldShow = _useContext.shouldShow;
  if (shouldShow || alwaysShow) {
    return children;
  }
  return null;
}
Element.propTypes = propTypes;
Element.defaultProps = defaultProps;